export default "__VITE_ASSET__DYUSYirQ__"